import { fetchAuthSession } from 'aws-amplify/auth';
import { get } from 'aws-amplify/api';
import { NEW_REST_API, NEW_REST_API__V3__PUBSUB } from '../consts';

// App startup and concurrent uploads must not race destructive policy rebuilds.
// Keep successful attachment for this identity for the lifetime of this page;
// membership-change endpoints rebuild policies when account access changes.
const attachments = new Map<string, Promise<void>>();

export async function ensureAccountIotPolicy(): Promise<void> {
  const { identityId } = await fetchAuthSession();
  if (!identityId) throw new Error('Missing authenticated identity');
  let attachment = attachments.get(identityId);
  if (!attachment) {
    attachment = get({
      apiName: NEW_REST_API,
      path: NEW_REST_API__V3__PUBSUB,
      options: { retryStrategy: { strategy: 'no-retry' } },
    }).response.then(() => undefined).catch(error => {
      attachments.delete(identityId);
      throw error;
    });
    attachments.set(identityId, attachment);
  }
  return attachment;
}
